// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"3993":"d3b25665","9305":"5c025fa9"}[chunkId] + "." + {"3993":"f2ab365307a7a0e6","9305":"ffed312064ffb352"}[chunkId] + ".js";
};